import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DeviceController } from './device.controller';
import { Device } from './device.entity';
import { DeviceService } from './device.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Device]),
  ],
  controllers: [DeviceController],
  providers: [DeviceService,ApplicationExceptionHandler]
})
export class DeviceModule {}
